// extracted by mini-css-extract-plugin
export var emptyState = "_70-d";
export var statCard = "_70-c";
export var table = "_70-0";
export var tableCell = "_70-4";
export var tableCellClickable = "_70-5 _70-4";
export var tableCellDefault = "_70-6 _70-4";
export var tableCellEmpty = "_70-8";
export var tableCellWithValue = "_70-7";
export var tableContainer = "_70-e";
export var tableHeaderWeight = "_70-1";
export var tableHeaderZone = "_70-2";
export var tableRowHeader = "_70-3";
export var viewModeButton = "_70-9";
export var viewModeButtonActive = "_70-a _70-9";
export var viewModeButtonInactive = "_70-b _70-9";